import { ApiError } from '../types'

/**
 * Create redux-friendly ApiError from Error-like object thrown by most APIs.
 */
export function createApiError(e: unknown): ApiError {
  if (typeof e === 'object' && e !== null) {
    return {
      stack: (e as unknown as Error).stack,
      fields: (e as unknown as ApiError).fields,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      errorDetails: (e as unknown as ApiError).errorDetails || (e as any).error_details,
      error: (e as unknown as ApiError).error || (e as unknown as Error).message || String(e),
      quota: (e as unknown as ApiError).quota,
      status: (e as unknown as ApiError).status || 0
    }
  } else if (typeof e === 'string') {
    return { status: 0, error: e }
  } else {
    return { status: 0, error: `unknown error type: '${typeof e}'` }
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isApiError(e: any): e is ApiError {
  return typeof e === 'object' && e !== null && typeof e.status === 'number' && typeof e.error === 'string'
}
